import { Resolutions } from 'src/app/models/trading-view';
import { HistoryCallback, ErrorCallback, LibrarySymbolInfo, PeriodParams, ResolutionString } from 'src/assets/tradingview/charting_library/datafeed-api';
import CryptoCandleService from './crypto-candle.service';

export class TradingViewDataFeed {
  symbolData: any;
  aedExchangeRate: number;

  constructor(pair: string, private cryptoCandleService: CryptoCandleService) {
    this.symbolData = {
      name: pair,
      description: '',
      session: '24x7',
      timezone: 'Etc/UTC',
      supported_resolutions: Object.values(Resolutions) as ResolutionString[],
      has_intraday: true,
      has_weekly_and_monthly: true,
      weekly_multiplier: ['1'],
      intraday_multipliers: Object.values(Resolutions).slice(0, -2),
      has_no_volume: true,
      minmov: 1,
      pricescale: this.getPrecision(pair),
      data_status: 'streaming'
    };

    // TODO: get this from server, do we need this
    this.aedExchangeRate = 3.67;
  }

  onReady(callback) {
    const config = {
      'supports_search': false,
      'supports_group_request': false,
      'supports_marks': true,
      'supports_timescale_marks': true,
      'supports_time': true,
      'exchanges': [],
      'symbols_types': [],
      'supported_resolutions': Object.values(Resolutions)
    };

    setTimeout(function () {
      callback(config);
    }, 0);
  }

  resolveSymbol(pair: string, onSymbolResolvedCallback: (pair: string) => void, onResolveErrorCallback: (error: string) => void) {
    const symbolData = this.symbolData;

    if (symbolData && symbolData.name === pair) {
      setTimeout(function () {
        onSymbolResolvedCallback(symbolData);
      }, 0);
    } else {
      setTimeout(function () {
        onResolveErrorCallback('No data provided for symbol ' + pair);
      }, 0);
    }
  }

  getBars(symbolInfo: LibrarySymbolInfo, resolution: ResolutionString, periodParams: PeriodParams, onResult: HistoryCallback, onError: ErrorCallback): void {
    this.cryptoCandleService.getHistory(symbolInfo.name, periodParams, resolution).subscribe(candles => {
      if (candles?.length === 0) {
        onResult([], { noData: true });
        return;
      }
      onResult(candles);
    },
      err => {
        onError(err?.errors?.[0].message);
      });
  }

  subscribeBars(symbolInfo, resolution, onRealtimeCallback, subscriberUID, onResetCacheNeededCallback) {
    this.cryptoCandleService.getRealtimeUpdates(symbolInfo.name, resolution, subscriberUID, onRealtimeCallback, onResetCacheNeededCallback);
  }

  unsubscribeBars(subscriberUID) {
    this.cryptoCandleService.unsubscribeLiveUpdates(subscriberUID);
  }

  // TODO: make it more general
  getPrecision(pair: string) {
    if (!pair) {
      return 100;
    }

    const [base, quote] = pair.split('-');

    // Quote Currency - for Crypto-Crypto
    if (['BTC', 'ETH'].includes(quote)) {
      return 1000000;
    }

    // Base Currency - for Fiat-Crypto and USDT pairs
    return Math.pow(10, this.cryptoCandleService.getCurrencyPrecision(base));
  }
}
